{
  "el": {
    "question_list": {
      "actions": {
        "cancel": "Αναίρεση",
        "cancelOrder": "Ακύρωση",
        "delete": "Διαγραφή",
        "deleteMultipleQuestionLists": "Διαγραφή...",
        "delete_cancel": "Ακύρωση",
        "edit": "Επεξεργασία",
        "new": "Λίστα FAQ",
        "reorderQuestions": "Αναδιάταξη ερωτήσεων",
        "save": "Αποθήκευση",
        "saveOrder": "Αποθήκευση σειράς",
        "submit": "Δημιουργία",
        "tickBoxesDeletion": "Επίλεξε τα πλαίσια ελέγχου των FAQ που θέλεις να διαγράψεις, και μετά πάτησε το κουμπί παραπάνω για να επιβεβαιώσεις ή να ακυρώσεις τη διαγραφή."
      },
      "attributes": {
        "description": "Περιγραφή",
        "name": "Όνομα",
        "question_list": "FAQ"
      },
      "labels": {
        "allUnits": "Όλα τα ακίνητα",
        "descriptionOptional": "Περιγραφή (προαιρετικό)",
        "editFAQ": "Επεξεργασία FAQ",
        "faq": "FAQ",
        "faq_all_projects": "FAQ όλων των έργων",
        "info": "Έχεις μια ερώτηση για το σπίτι σου; Έλα να δεις τις πιο συχνές ερωτήσεις και τις απαντήσεις τους.",
        "questions": " Καμία ερώτηση | 1 ερώτηση | {count} ερωτήσεις",
        "questions_count": "Ερωτήσεις",
        "showQuestionListFor": "Εμφάνιση FAQ για",
        "title": "Συχνές ερωτήσεις"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "Εδώ θα βρεις απαντήσεις σε γενικές ερωτήσεις ή ερωτήσεις που έχουν κάνει άλλοι.",
            "title": "Συχνές ερωτήσεις"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Δώσε απαντήσεις σε γενικές ερωτήσεις που μπορεί να έχουν οι πελάτες σου.",
            "title": "Δημιούργησε την πρώτη σου λίστα FAQ"
          }
        }
      },
      "toasts": {
        "create": "Η λίστα FAQ δημιουργήθηκε",
        "delete": "Η λίστα FAQ διαγράφηκε",
        "update": "Η λίστα FAQ ενημερώθηκε"
      },
      "validation": {
        "needName": "Απαιτείται τίτλος",
        "selectQuestionList": "Επίλεξε τουλάχιστον 1 FAQ"
      }
    }
  }
}
